import React from "react";
import { Dropdown } from "react-bootstrap";
import { BsLayoutThreeColumns } from "react-icons/bs";

const PrimarySelector = ({
  items,
  icon,
  textOnly = false,
  grayScale = false,
  iconRight = false,
  handleChange,
  value,
}) => {
  return (
    <>
      <Dropdown
        className={`primary-selector ${grayScale && "grayscale"} ${
          iconRight && "icon-right"
        }`}
        onSelect={handleChange}
      >
        <Dropdown.Toggle>
          {icon ? icon : null} {value}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {!textOnly ? (
            <>
              {items.map((item) => {
                return (
                  <>
                    <Dropdown.Item eventKey={item}>
                      <div className="flex-wrap-items flex-sm">
                        <input type="checkbox" />
                        <label htmlFor="">{item}</label>
                      </div>
                    </Dropdown.Item>
                  </>
                );
              })}
            </>
          ) : (
            <>
              {items.map((item) => {
                return (
                  <>
                    <Dropdown.Item eventKey={item}>{item}</Dropdown.Item>
                  </>
                );
              })}
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default PrimarySelector;
